export enum TipoCredor {
    ORIGINARIO,
    SUCESSOR,
    ADVOGADO,
    CESSIONARIO
}